import { i18n } from "services/i18nService";
import { formatNameLinkField } from "services/utility/formatting";
import { formatBooleanYesOrBlank } from "services/utility/formatting";

export const columnInfo = [
  {
    name: "name",
    fixed: true,
    heading: i18n("columns.Name"),
    formatFunc: formatNameLinkField,
    defaultSort: true,
    linkField: true,
    sortable: true,
  },
  {
    heading: i18n("columns.Description"),
    name: "description",
    sortable: true,
    fixedRightOfAction: true,
    fixed: true,
  },
  {
    heading: i18n("columns.App"),
    name: "connectionType",
    sortable: true,
    fixedRightOfAction: true,
    fixed: true,
  },
  {
    name: "enabled",
    heading: i18n("columns.Enabled"),
    formatFunc: formatBooleanYesOrBlank,
    fixedRightOfAction: true,
    fixed: true,
  },
  {
    name: "billable",
    heading: i18n("columns.Billable"),
    formatFunc: formatBooleanYesOrBlank,
    fixedRightOfAction: true,
    fixed: true,
  },
];

const columnArray = Object.entries(columnInfo);
const defaultColumnInfo = columnArray.filter((col) => col[1].required);
export const defaultColumns = defaultColumnInfo.map((col) => col[0]);

export const LINE_ACTIONS = ["delete"];
export const BATCH_ACTIONS = ["delete"];

export function getEmptyRecord() {
  return {
    name: null,
    description: null,
    connectionType: "Shopify",
    authorizationField1: null,
    authorizationField2: null,
    storeIdentifier: null,
    enabled: true,
    billable: false,
    channel: null,
    class: null,
    customer: null,
    department: null,
    location: null,
    taxExemptTaxCode: null,
    shopifyAppType: CUSTOM_APP_ID,
    depositAccount: null,
    useSosDescription: false,
    useSosOrderNumber: false,
    useCommonCustomer: false,
    updateInventory: false,
    txnType: AUTO_DETECT_OPTION.id,
    paymentMethod: null,
    incomeAccount: null,
    feeAccount: null,
  };
}

export const CONNECTION_TYPE_OPTIONS = ["Shopify", "BigCommerce", "PayPal"];

export const CUSTOM_APP_ID = "custom";
export const PRIVATE_APP_ID = "private";

export const SHOPIFY_TYPE_OPTIONS = [
  { id: PRIVATE_APP_ID, name: i18n("cart.private") },
  { id: CUSTOM_APP_ID, name: i18n("cart.custom") },
];

export const AUTO_DETECT_OPTION = {
  id: "Auto-Detect",
  name: i18n("cart.AutoDetect"),
};

export const TRANSACTION_TYPE_OPTIONS = [
  AUTO_DETECT_OPTION,
  { id: "SO", name: i18n("cart.SalesOrders") },
  { id: "SR", name: i18n("cart.SalesReceipts") },
  { id: "None", name: i18n("cart.DontImport") },
];
